module.exports = __webpack_public_path__ + "static/media/sharing-articles.328330e5.svg";